import { render, staticRenderFns } from "./finantial-settings-payout-methods-page.vue?vue&type=template&id=4a5d60bb&scoped=true&"
import script from "./finantial-settings-payout-methods-page.vue?vue&type=script&lang=js&"
export * from "./finantial-settings-payout-methods-page.vue?vue&type=script&lang=js&"
import style0 from "./finantial-settings-payout-methods-page.vue?vue&type=style&index=0&id=4a5d60bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5d60bb",
  null
  
)

export default component.exports